import { EventRegistry } from '../../../../../domain/event/event.registry';
import { FieldEvent } from './field.event';
export class FieldDeletedEvent extends FieldEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `field/${payload.id}`,
            type: FieldDeletedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldDeletedEvent.type = 'com.treeplotter.api.field.deleted.v1';
EventRegistry.register(FieldDeletedEvent.type, FieldDeletedEvent);
//# sourceMappingURL=field-deleted.event.js.map